import { z } from 'zod'
import { oc } from '@orpc/contract'
import { copayStatusSchema, patientInvoiceKindSchema } from './copay-status.contract'

// A patient payment taken outside Stripe (card at the front desk, check, ACH, virtual card):
// the Invoice of the kind goes straight to balanced carrying the method; the billing sweep
// projects it into the ledger. No Stripe session, no receipt, no Stripe refund.
export const recordPatientPayment = oc
  .route({ method: 'POST', path: '/v2/copay/{encounterId}/record' })
  .input(
    z.object({
      encounterId: z.string().min(1),
      kind: patientInvoiceKindSchema.default('copay'),
      amountCents: z.number().int().min(1).max(500_000),
      method: z.enum(['card', 'vcc', 'ach_eft', 'check']),
      /** Calendar date (YYYY-MM-DD) the patient paid. */
      paymentDate: z.iso.date(),
      /** Check number / trace — audit note only. */
      reference: z.string().min(1).optional(),
    }),
  )
  .output(copayStatusSchema)
